jQuery(document).ready(function ($) {
    // toggle faq questions
    $(document).on('click', '.faq-question', function () {
        $(this).toggleClass('open');
        $(this).next('.faq-answer').toggleClass('open');
    });

    // toggle faq categories
    $(document).on('click', '.faq-category > button.faq-category', function () {
        $(this).toggleClass('open');
        $(this).next('.faq-answers').slideToggle(200);
    });

    // search
    $('.faq-search-input').on('input', function () {
        var value = $(this).val().toLowerCase().trim();

        // reset to default state if search is empty
        if (value === '') {
            $('.faq-category').each(function () {
                $(this).show();
                $(this).find('.faq-item').show();
                var $btn = $(this).children('button.faq-category');
                $btn.removeClass('open');
                $(this).children('.faq-answers').stop(true, true).hide();
                $(this).find('.faq-question').removeClass('open');
                $(this).find('.faq-answer').removeClass('open');
            });
            return;
        }

        // filter items based on search query
        $('.faq-category').each(function () {
            var $category = $(this);
            var visibleCount = 0;

            $category.find('.faq-item').each(function () {
                var q = $(this).find('.faq-question').text().toLowerCase();
                var a = $(this).find('.faq-answer').text().toLowerCase();
                if (q.indexOf(value) !== -1 || a.indexOf(value) !== -1) {
                    $(this).show();
                    visibleCount++;
                } else {
                    $(this).hide();
                }
            });

            if (visibleCount === 0) {
                $category.hide();
            } else {
                $category.show();
                var $btn = $category.children('button.faq-category');
                $btn.addClass('open');
                $category.children('.faq-answers').stop(true, true).show();
            }
        });
    });

    // open category and item if anchor exists
    function openAnchorTarget() {
        if (window.location.hash && window.location.hash.startsWith('#faq-item-')) {
            var $target = $(window.location.hash);
            if ($target.length) {
                var $category = $target.closest('.faq-category');
                if ($category.length) {
                    $category.show();
                    var $btn = $category.children('button.faq-category');
                    $btn.addClass('open');
                    $category.children('.faq-answers').show();
                }
                var $q = $target.find('.faq-question');
                var $a = $target.find('.faq-answer');
                $q.addClass('open');
                $a.addClass('open');
                setTimeout(function () {
                    var offset = $target.offset().top - 100;
                    $('html, body').animate({scrollTop: offset}, 600);
                }, 200);
            }
        }
    }

    openAnchorTarget();
    $(window).on('hashchange', openAnchorTarget);
});
